(function () {

  'use strict';

  function pxPrinterPropertiesSelectSnmp($timeout, SnmpConfigurationService, SnmpConfigurationsPaging) {
    return {
      restrict: 'EA',
      scope: {
        networkIds: '=',
        callback: '&'
      },
      templateUrl: 'app/components/printerPropertiesMulti/printerPropertiesSelectSnmp/printerPropertiesSelectSnmp.template.html',
      link: function (scope) {

        scope.loading = false;
        scope.paging = new SnmpConfigurationsPaging();
        scope.snmpConfigurations = [];
        scope.totalPages = 0;

        scope.textSearch = function () {
          getFirstPageOfSnmpConfigurations();
        };

        scope.selectSnmpConfiguration = function (event, snmpConfiguration) {
          event.stopPropagation();
          scope.callback({ snmpConfiguration: snmpConfiguration });
        };

        scope.closePopup = function (event) {
          scope.callback();
        };

        function getFirstPageOfSnmpConfigurations() {
          scope.loading = true;
          scope.paging.pagingCriteria.page = 0;
          scope.paging.pagingCriteria.pageSize = 10;
          scope.paging.pagingCriteria.networkIds = scope.networkIds && scope.networkIds.length ? scope.networkIds : null;
          scope.paging.pagingCriteria.global = scope.networkIds && scope.networkIds.length ? null : true;
          SnmpConfigurationService.getSnmpConfigurationsPaged(scope.paging).then(function (response) {
            scope.snmpConfigurations = SnmpConfigurationService.extractSnmpConfigurationsFromResponse(response);
            scope.totalPages = response.data.page.totalPages;
            scope.loading = false;
          }).catch(function(response) {
            scope.loading = false;
          });
        };

        function getNextPageOfSnmpConfigurations() {
          scope.loading = true;
          scope.paging.pagingCriteria.page += 1;
          SnmpConfigurationService.getSnmpConfigurationsPaged(scope.paging).then(function (response) {
            const snmpConfigurations = SnmpConfigurationService.extractSnmpConfigurationsFromResponse(response);
            scope.snmpConfigurations.push(...snmpConfigurations);
            scope.totalPages = response.data.page.totalPages;
            scope.loading = false;
          }).catch(function(response) {
            scope.loading = false;
          });
        };

        function attachScrollHandler() {
          angular.element('.pagination-items').on('scroll', scrollHandler);
        }

        function detachScrollHandler() {
          angular.element('.pagination-items').off('scroll', scrollHandler);
        }

        let scrollTimeout = null;

        function scrollHandler(event) {
          if (!scope.loading && scope.totalPages > scope.paging.pagingCriteria.page + 1) {
            const element = event.currentTarget;
            if (Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) <= 1) {
              if (scrollTimeout) {
                $timeout.cancel(scrollTimeout);
              }
              scrollTimeout = $timeout(function () {
                scrollTimeout = null;
                getNextPageOfSnmpConfigurations();
              }, 300);
            }
          }
        }

        (function () {
          attachScrollHandler();
          scope.$on('$destroy', function () {
            detachScrollHandler();
          });
        })();

        scope.$watch(function () {
          return scope.networkIds;
        }, function () {
          getFirstPageOfSnmpConfigurations();
        });

      }
    };
  }

  pxPrinterPropertiesSelectSnmp.$inject = ['$timeout', 'SnmpConfigurationService', 'SnmpConfigurationsPaging'];

  angular
    .module('printix-admin')
    .directive('pxPrinterPropertiesSelectSnmp', pxPrinterPropertiesSelectSnmp);

})();
